export interface CursorPage<T> {
  content: T[];
  nextCursor: string | null;
}

export interface DispatchRecord {
  dispatchId: string;
  locationId: string;
  notificationType: string;
  recipient: string;
  channel: string;
  dispatchedAt: string;
  recordedAt: string;
  suppressed: boolean;
  suppressionReason: string | null;
}

export interface StatusPeriod {
  entityType: string;
  entityId: string;
  locationId: string;
  status: string;
  startedAt: string;
  endedAt: string | null;
  durationSeconds: number;
  alertedAt: string | null;
  alertScope: string | null;
  remindedAt: string | null;
}

export type ViewState = "loading" | "ready" | "empty" | "refused" | "failed";

export type EntityType = "EVSE" | "LOCATION";

export const EVSE_STATUSES = [
  "AVAILABLE",
  "CHARGING",
  "RESERVED",
  "REMOVED",
  "TIME_OUT",
  "OUT_OF_ORDER",
];

export const LOCATION_STATUSES = [
  "AVAILABLE",
  "PARTIALLY_AVAILABLE",
  "OCCUPIED",
  "RESERVED",
  "TIME_OUT",
  "OUT_OF_ORDER",
  "REMOVED",
];

export interface StationExclusion {
  stationId: string;
  stationName: string | null;
  stationFound: boolean;
  published: boolean | null;
  note: string | null;
  excludedAt: string;
  excludedForSeconds: number;
  excludedBy: string;
}

export type ExclusionOutcome = "ADDED" | "ALREADY_EXCLUDED" | "UNKNOWN_STATION";

export interface ExclusionResult {
  stationId: string;
  outcome: ExclusionOutcome;
}
